import { useState } from "react";
import { useHistory } from "react-router-dom";

import {
    Button, Chip, Dialog, DialogActions,
    DialogContent, DialogTitle, Typography
} from "@material-ui/core";
import { Undo } from "@material-ui/icons";

import LoadingProgress from "../LoadingProgress";

import requestReturnService from "../../domain/services/request/request.return.service";
import { appConstants } from '../../domain/constant/app.constant';

const MIN_HOURS_BEFORE_OPERATIONAL_DUE_DATE = 12;

const hoursUntilOperationalDueDate = (request) => {

    if (!request?.operationalDueDate)
        return null;

    const millisecondsLeft = new Date(request.operationalDueDate).getTime() - Date.now();

    return millisecondsLeft / (1000 * 60 * 60);
};

const hasMarginToReturn = (request) => {

    const hoursLeft = hoursUntilOperationalDueDate(request);

    if (hoursLeft === null)
        return true;

    return hoursLeft >= MIN_HOURS_BEFORE_OPERATIONAL_DUE_DATE;
};

function FaciliterReturnToNotStarted({ request, setAlert }) {

    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const canReturn = hasMarginToReturn(request);

    const onConfirm = async () => {

        setLoading(true);

        return requestReturnService
            .returnToNotStarted(request.id)
            .then(() => history.push("/solicitations"))
            .catch(error => setAlert((error?.response?.data?.message || "Não foi possível devolver o serviço para a central."), "error"))
            .finally(() => setLoading(false));
    }

    return (
        <>

            <Chip
                label="Devolver para a central"
                icon={<Undo />}
                onClick={() => setOpen(true)}
                variant="outlined"
                style={{ height: '100%' }}
            />

            <Dialog
                open={open} disableEscapeKeyDown={loading}
                onClose={() => !loading && setOpen(false)}
            >

                <DialogTitle style={{ backgroundColor: '#eee' }}>
                    Devolver para a central
                </DialogTitle>

                <DialogContent>

                    {!loading && canReturn &&
                        <div style={{ padding: "10px" }}>
                            <Typography>
                                A solicitação volta para a central e é oferecida a outro profissional. Devolvendo agora, você não recebe multa e a sua pontualidade não é afetada.
                            </Typography>
                            <Typography style={{ marginTop: 12 }}>
                                A devolução fica disponível até {MIN_HOURS_BEFORE_OPERATIONAL_DUE_DATE} horas antes do prazo operacional. Devoluções frequentes são acompanhadas pela operação.
                            </Typography>
                        </div>
                    }

                    {!loading && !canReturn &&
                        <div style={{ padding: "10px" }}>
                            <Typography>
                                O prazo operacional está a menos de {MIN_HOURS_BEFORE_OPERATIONAL_DUE_DATE} horas, então a devolução pela plataforma não está mais disponível e a entrega segue com você.
                            </Typography>
                            <Typography style={{ marginTop: 12 }}>
                                Se surgiu um impedimento sério, fale com o suporte pelo e-mail {appConstants.faciliterSupportEmail} para avaliarmos o caso juntos.
                            </Typography>
                        </div>
                    }

                    {loading && LoadingProgress("Devolvendo...")}

                </DialogContent>

                <DialogActions>

                    {canReturn &&
                        <>
                            <Button
                                onClick={() => setOpen(false)}
                                style={{ color: "#FF5959" }} disabled={loading}
                            >
                                Cancelar
                            </Button>

                            <Button
                                onClick={() => onConfirm()}
                                color="primary" disabled={loading}
                            >
                                Devolver serviço
                            </Button>
                        </>
                    }

                    {!canReturn &&
                        <Button
                            onClick={() => setOpen(false)}
                            color="primary"
                        >
                            Entendi
                        </Button>
                    }

                </DialogActions>

            </Dialog>

        </>
    )
}

export default FaciliterReturnToNotStarted;
